// import Vue from 'vue'

export default {
    name : 'contact-company',
    init() {
        if (document.getElementById('contact-company')) {
            this.run();
        }
    },

    run ()
    {
        new Vue({
            el: '#contact-company',

            delimiters: ['@{', '}'],

            data :
            {
                items : [],
                results : [],
                keyword : ""
            },

            methods:
            {
                getCompanies()
                {
                    const url = "/actions/tibe/companies/index";

                    return new Promise(resolve => {
                        fetch(url)
                            .then(response => response.json())
                            .then(data => {
                                this.results = this.items = data.items;
                            });
                        }
                    );
                },

                searchItem()
                {
                    if (this.keyword.length >= 3) {
                        this.results = [];

                        this.items.forEach( (item) => {
                            // _log(item.title);
                            let title = (item.title.toLowerCase().search(this.keyword) !== -1);
                            let address = (item.address.toLowerCase().search(this.keyword) !== -1);
                            let city = (item.city.toLowerCase().search(this.keyword) !== -1);

                            if (title || address || city) {
                                this.results.push(item);
                            }
                        });
                    } else {
                        this.results = this.items;
                    }
                },

                printAddress(item)
                {
                    let address = [];
                    if (item.address) {
                        address.push(item.address);
                    }

                    if (item.postalCode || item.city) {
                        address.push(item.postalCode+' '+item.city);
                    }

                    return address.join(", ");
                },

                link(value, prefix)
                {
                    return prefix+":"+value.replace(' ', '');
                }

            },
            created ()
            {
                // _log('contact ready');
                this.getCompanies();
            }
      });
    }
}